import type { ComponentMultiStyleConfig } from '@chakra-ui/theme'

const Alert: ComponentMultiStyleConfig = {
  parts: ['title', 'description', 'container', 'icon'],
  baseStyle: {
    container: {
      borderRadius: '6px',
    },
  },
}

export default Alert
